import { lazy } from 'react';

import { withSuspense } from '@/shared/lib/hocs/with-suspense.hoc';
import { PageLoader } from '@/widgets/page';

export const UsersManagementPage = withSuspense(
	lazy(async () => await import('./users-management-page.component')),
	PageLoader,
);
